const NAMESPACE = 'mobile-show-more';

Carbon('Gator')(document).on('click', `.${NAMESPACE}__button`, function () {
    this.blur();
    let element = this.closest(`.${NAMESPACE}`);
    if (element) {
        element.classList.add(`${NAMESPACE}--active`);
        setTimeout(() => {
            this.parentNode.removeChild(this);
            element.classList.remove(NAMESPACE);
            element.classList.remove(`${NAMESPACE}--active`);
        }, 1200);
    }
});
